
(function () {
  'use strict';

  var MEDIA = {
    aerial: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-audit-west-dallas-aerial.jpg?v=1785782676', 'Aerial view of Gallery DeFi and its West Dallas setting'],
    crowd: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-curated-culture-crowd.jpg?v=1785543924', 'A lively art and culture crowd inside Gallery DeFi'],
    date: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-exp-date-night-v3.jpg?v=1785702973', 'Guests sharing an intimate private dining experience inside Gallery DeFi'],
    dinner23: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-audit-private-dining-23.jpg?v=1785782676', 'Guests seated for an intimate private dining experience inside Gallery DeFi'],
    dinner37: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-audit-private-dining-37.jpg?v=1785782676', 'Gallery DeFi private dinner surrounded by immersive art'],
    dinner39: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-audit-private-dining-39.jpg?v=1785782676', 'Guests and chef at a Gallery DeFi private dining event'],
    privateEvent: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-exp-private-event-v2.jpg?v=1785637243', 'Private event guests inside Gallery DeFi'],
    group: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-exp-group-visit-v2.jpg?v=1785637241', 'A group gathering inside Gallery DeFi in West Dallas'],
    room: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-exp-closing-room-v2.jpg?v=1785637243', 'Wide interior view of Gallery DeFi in West Dallas'],
    leah: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gallery-defi-leah-kirsch-installation.jpg?v=1783689139', 'Leah Kirsch artist installation at Gallery DeFi'],
    immersive: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gallery-defi-immersive-installation.png?v=1783688848', 'Immersive installation inside Gallery DeFi'],
    mural: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-curated-space-mural-room.jpg?v=1785543979', 'Large-scale mural room inside Gallery DeFi'],
    art1: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/PhotoAug282025_112705AM_2.jpg?v=1756424563', 'Texas Smoke Em fine art print by Jude'],
    art2: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/Photo_Aug_28_2025_11_27_05_AM_4_3766d0c2-7d6a-44f5-b176-e63810c86f92.jpg?v=1783073964', 'Bad Habits fine art print by Jude'],
    art3: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/PhotoAug262025_115959PM_2_22c02b36-0da5-4ead-b7d0-a37a3ff71f5c.jpg?v=1756424056', 'Fuzz limited edition print by Minji Kang-Watrous'],
    art4: ['https://cdn.shopify.com/s/files/1/0550/6826/2490/files/CHRIS-BradyMatthews.jpg?v=1756253861', 'Chris Farley fine art print by Brady Matthews']
  };

  function currentHandle() {
    var path = window.location.pathname.replace(/\/+$/, '');
    return path.split('/').pop() || '';
  }

  function mediaFor(key) {
    var item = MEDIA[key];
    return item ? { src: item[0], alt: item[1] } : null;
  }

  function replaceImage(image, media) {
    if (!image || !media) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.setAttribute('src', media.src);
    image.setAttribute('data-src', media.src);
    image.setAttribute('data-srcset', media.src);
    image.setAttribute('alt', media.alt || '');
    image.setAttribute('decoding', 'async');
    image.classList.remove('lazyload', 'lazyautosizes');
    image.classList.add('lazyloaded');
  }

  function moveAuditMarkup() {
    document.querySelectorAll('[data-gd-photo-audit-movable]').forEach(function (node) {
      if (node.dataset.gdPhotoMounted === 'true') return;
      var target = document.querySelector(node.getAttribute('data-gd-photo-target') || '');
      if (!target) return;
      var placement = node.getAttribute('data-gd-photo-placement') || 'before';
      if (placement === 'after') target.insertAdjacentElement('afterend', node);
      else if (placement === 'inside-after') target.appendChild(node);
      else target.insertAdjacentElement('beforebegin', node);
      node.dataset.gdPhotoMounted = 'true';
      node.classList.add('is-mounted');
    });
  }

  function updateVisualBreak() {
    var config = document.getElementById('gd-photo-audit-route-config');
    var section = document.querySelector('.gd-visual-break');
    if (!config || !section) return;

    var type = config.dataset.type || 'visit';
    section.classList.add('gd-photo-audit--' + type);
    var eyebrow = section.querySelector('.gd-visual-break__eyebrow');
    var title = section.querySelector('.gd-visual-break__heading h2');
    var copy = section.querySelector('.gd-visual-break__heading p:not(.gd-visual-break__eyebrow)');
    var cta = section.querySelector('.gd-visual-break__button');
    if (eyebrow) eyebrow.textContent = config.dataset.eyebrow || '';
    if (title) title.textContent = config.dataset.title || '';
    if (copy) copy.textContent = config.dataset.copy || '';
    if (cta) {
      cta.textContent = config.dataset.cta || 'Continue';
      cta.setAttribute('href', config.dataset.href || '/pages/tickets');
    }

    var keys = (config.dataset.images || '').split(',').filter(Boolean);
    var images = Array.prototype.slice.call(
      section.querySelectorAll('.gd-visual-break__culture-item img, .gd-visual-break__space-item img')
    );
    images.forEach(function (image, index) {
      replaceImage(image, mediaFor(keys[index % keys.length]));
    });

    var actions = document.querySelector('.gd-full-bleed-page .gd-seo-actions');
    if (actions) actions.insertAdjacentElement('afterend', section);
  }

  function updateTicketCards() {
    if (currentHandle() !== 'tickets') return;
    var keys = ['room', 'date', 'group'];
    document.querySelectorAll('.spotlight-block .spotlight--image .image-container img').forEach(function (image, index) {
      if (index < keys.length) replaceImage(image, mediaFor(keys[index]));
    });
  }

  function enforceArtistImageQuality() {
    var handle = currentHandle();
    if (handle === 'dot-daniel-shoykhet') {
      document.querySelectorAll('.gd-artist-profile__portrait, .gd-artist-card__image').forEach(function (frame) {
        frame.classList.add('gd-photo-audit-compact');
      });
    }
    if (handle === 'josh-mayhem') {
      document.querySelectorAll('.gd-artist-profile__gallery-item').forEach(function (figure) {
        var image = figure.querySelector('img');
        var src = image ? (image.currentSrc || image.src || '') : '';
        if (src.indexOf('websiteQRcode') !== -1) figure.classList.add('gd-photo-audit-hidden');
      });
      var selected = document.querySelector('.gd-artist-profile__selected');
      if (selected && !selected.querySelector('.gd-artist-profile__gallery-item:not(.gd-photo-audit-hidden)')) {
        selected.classList.add('gd-photo-audit-empty');
      }
    }
    document.querySelectorAll('.gd-artist-profile__work-card').forEach(function (card) {
      var frame = card.querySelector('.gd-artist-profile__work-image');
      if (!frame || frame.querySelector('img') || frame.querySelector('.gd-photo-audit-media-pending')) return;
      var title = card.querySelector('h3');
      frame.innerHTML = pendingMarkup(title ? title.textContent.trim() : 'Artist work');
    });
  }

  function enhanceCatalogFallbacks() {
    document.querySelectorAll('.gd-product-gallery__fallback, .gd-collection-card__fallback, .gd-collection-index-card__fallback').forEach(function (fallback) {
      if (fallback.dataset.gdPhotoReady === 'true') return;
      fallback.dataset.gdPhotoReady = 'true';
      var card = fallback.closest('article, a, section, .gd-product') || fallback.parentElement;
      var title = card && card.querySelector('h1,h2,h3');
      fallback.innerHTML = pendingMarkup(title ? title.textContent.trim() : 'Gallery DeFi catalog record');
    });
    document.querySelectorAll('.gd-product-related-card__media').forEach(function (frame) {
      if (frame.querySelector('img')) return;
      var span = frame.querySelector('span');
      if (span) span.textContent = 'Photography pending';
    });
  }

  function improveEditorialImages() {
    var isEvents = window.location.pathname.indexOf('/blogs/events') === 0;
    document.querySelectorAll('.gd-editorial-hero img, .gd-event-detail__hero img, .gd-blog-card__image img').forEach(function (image) {
      var alt = (image.getAttribute('alt') || '').toLowerCase();
      var generic = alt.indexOf('contemporary immersive art') !== -1 || alt.indexOf('gallery defi editorial') !== -1;
      if (generic) replaceImage(image, mediaFor(isEvents ? 'crowd' : 'leah'));
      var width = parseInt(image.getAttribute('width') || '0', 10);
      if (width && width < 700) {
        var frame = image.closest('.gd-editorial-hero, .gd-event-detail__hero, .gd-blog-card__image');
        if (frame) frame.classList.add('gd-photo-audit-contained');
      }
    });
  }

  function pendingMarkup(title) {
    return '<div class="gd-photo-audit-media-pending"><span><small>Gallery DeFi catalog record</small><strong>' +
      escapeHtml(title) + '</strong><em>Photography pending</em></span></div>';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function boot() {
    moveAuditMarkup();
    updateVisualBreak();
    updateTicketCards();
    enforceArtistImageQuality();
    enhanceCatalogFallbacks();
    improveEditorialImages();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('load', function () {
    updateTicketCards();
    enforceArtistImageQuality();
    improveEditorialImages();
  }, { once: true });
  document.addEventListener('shopify:section:load', boot);
})();
